import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidenav from './common/Sidenav';
import Topnav from './common/Topnav';
import Footer from './common/Footer';
import Bottom from './common/Bottom';
import Users from './User/Users';
import Orders from './Order/Orders';
import Products from './Product/Products';
import Landing from './Landing';
import NewOrder from './Order/NewOrder';

const Dashboard = () => {

    return (
        <div className="sqtech-dashboard">
            <div id="wrapper">
                <Sidenav />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Topnav />
                        <div className="container-fluid">
                            <Routes>
                                <Route path="/" element={<Landing />} />
                                <Route path="products" element={<Products />} />
                                <Route path="orders" element={<Orders />} />
                                <Route path="order/new" element={<NewOrder />} />
                                <Route path="users" element={<Users />} />
                            </Routes>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            <Bottom />
        </div>
    );
};

export default Dashboard;
